import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/CLOUDWEB-17449 Р7-Офис. Реализация MVP в деве через API */
export const IS_EDITORS_CONSISTENCY_ENABLED = isFeature('is-editors-consistency-enabled');
